// import lightGallery from 'lightgallery.js'

import 'lightgallery.js';
// import 'lg-zoom.js';
// import 'lg-pager.js';
// import 'lg-fullscreen.js';
// import 'lg-thumbnail.js';
// import 'lg-autoplay.js';
// import 'lg-share.js';

import Isotope from 'isotope-layout'

export default {
  init() {
    console.log('gallery');
    // Gallery
    const gallery = document.getElementById('lightgallery')
        
    if(gallery){
      // lightGallery(gallery, {
      //   speed: 600,
      //   subHtmlSelectorRelative: true,
      //   selector: '.gallery-item'
      // }); 

      createGallery(gallery, '.gallery-item')

      var iso = new Isotope( '.grid', {
        masonry: {
          columnWidth: '.grid-sizer',
          gutter: '.gutter-sizer'
        },
        itemSelector: '.gallery-item',
        percentPosition: true,
        getSortData: {
          name: '.name',
          category: '[data-category]'
        },
      });




      const filtersElem = document.querySelector('.gallery-filters')
      if(filtersElem){
        const buttons = filtersElem.getElementsByTagName('button');

        filtersElem.addEventListener( 'click', function( event ) {

          for(let button of buttons){
            button.classList = ''
          }

          event.target.classList = 'active';
          var filterValue = event.target.getAttribute('data-filter');
          iso.arrange({ filter: filterValue });

          destroyGallery(gallery)
          createGallery(gallery, filterValue)

        });
      }
      
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};


function createGallery(el, selector){
  lightGallery(el, {
    speed: 600,
    subHtmlSelectorRelative: true,
    selector: selector
  }); 
}

function destroyGallery(el){
  window.lgData[el.getAttribute('lg-uid')].destroy(true);
}



